import { useForm } from '@mantine/form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { IdeaForm, IdeaFormValues } from 'src/Components/Forms/Idea/IdeaForm';
import { SlateNode } from 'src/Components/Shared/SlateRenderer/SlateRenderer.types';
import useCreateProject from 'src/Hooks/Mutations/useCreateProject';
import { CreateProjectDtoStatusEnum } from 'src/Services/API/generated/api';

import { Props } from './IdeaCreationFormWrapper.types';

const EMPTY_DESCRIPTION: SlateNode[] = [
  {
    type: 'paragraph',
    children: [{ text: '' }],
  },
];

const isDescriptionEmpty = (description: SlateNode[]) => {
  if (!description || description.length === 0) return true;
  return JSON.stringify(description) === JSON.stringify(EMPTY_DESCRIPTION);
};

const IdeaCreationFormWrapper = ({ onClose }: Props) => {
  const { t } = useTranslation();
  const { assetId } = useParams<{ assetId: string }>();
  const { mutate: createProject, isLoading } = useCreateProject(assetId!);

  const form = useForm<IdeaFormValues>({
    initialValues: {
      title: '',
      description: EMPTY_DESCRIPTION,
      attachments: [],
    },
    validate: {
      title: (value: string) =>
        value && value.length < 2 ? t('common.errors.tooShort', 'Trop court') : null,
    },
  });

  const handleSubmit = (values: IdeaFormValues) => {
    const payload = {
      title: values.title,
      description: isDescriptionEmpty(values.description)
        ? undefined
        : JSON.stringify(values.description),
      status: CreateProjectDtoStatusEnum.IdeaBox,
      attachmentIds: values.attachments.map(a => a.fileId).filter(Boolean) as string[],
    };

    createProject(payload, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <IdeaForm
      form={form}
      onSubmit={form.onSubmit(handleSubmit)}
      onCancel={onClose}
      isLoading={isLoading}
    />
  );
};

export default IdeaCreationFormWrapper;
